<template>
  <div>
    <span>
      <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
        <template v-slot:button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="16"
            class="text-body align-middle mr-25"
          />
        </template>
        <!-- Edit User -->
        <b-dropdown-item @click="onClickShowEditModal">
          <feather-icon icon="EditIcon" class="mr-50" />
          <span>Chỉnh sửa</span>
        </b-dropdown-item>

        <!-- Add Money -->
        <b-dropdown-item @click="onClickshowMoneyModal">
          <feather-icon icon="DollarSignIcon" class="mr-50" />
          <span>Thêm tiền</span>
        </b-dropdown-item>

        <!-- Delete User -->
        <b-dropdown-item @click="onClickShowDeleteModal">
          <feather-icon icon="TrashIcon" class="mr-50" />
          <span>Xóa người dùng</span>
        </b-dropdown-item>

        <!-- Block withdraw -->
        <b-dropdown-item @click="onClickShowBlockWidthDraw">
          <feather-icon v-if="user.isWithdraw" icon="UnlockIcon" class="mr-50"/>
          <feather-icon v-else icon="LockIcon" class="mr-50"/>
          <span>{{user.isWithdraw ? 'Mở rút tiền' : 'Khoá rút tiền'}}</span>
        </b-dropdown-item>

        <!-- Block order -->
        <b-dropdown-item @click="onClickShowBlockOrderModal">
          <feather-icon v-if="user.isBet" icon="UnlockIcon" class="mr-50"/>
          <feather-icon v-else icon="LockIcon" class="mr-50"/>
          <span>{{user.isBet ? 'Mở giao dịch' : 'Khoá giao dịch'}}</span>
        </b-dropdown-item>
      </b-dropdown>
    </span>

    <!-- Edit Modal -->
    <b-modal v-model="showEditModal" centered title="Chỉnh sửa người dùng">
      <!-- Username -->
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1 text-nowrap">Tên đăng nhập</label>
          <b-form-input
            type="text"
            v-model="editData.username"
            class="d-inline-block"
            disabled
          />
        </div>
      </b-form-group>

      <!-- Money -->
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1 text-nowrap">Số tiền</label>
          <b-form-input
            type="number"
            v-model="editData.money"
            class="d-inline-block"
            disabled
          />
        </div>
      </b-form-group>

      <!-- Password -->
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1 text-nowrap">Mật khẩu</label>
          <b-form-input
            type="text"
            v-model="editData.password"
            placeholder="Nhập mật khẩu"
            class="d-inline-block"
          />
        </div>
      </b-form-group>

      <b-form-group v-if="!editData.banks.length">
        <div class="d-flex align-items-center">
          <label class="mr-1 text-nowrap">Mật khẩu người dùng</label>
          <b-form-input
            type="text"
            :value="editData.passwordOriginal"
            placeholder="Chưa có"
            class="d-inline-block"
            disabled
          />
        </div>
      </b-form-group>

      <!-- Banks -->
      <div v-if="editData.banks.length">
        <p class="mt-2 mb-1">Ngân hàng</p>
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1 text-nowrap">Quốc gia</label>
            <b-form-input
              type="text"
              v-model="editData.banks[0].country"
              placeholder="Nhập quốc gia"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1 text-nowrap">Tỉnh/thành phố</label>
            <b-form-input
              type="text"
              v-model="editData.banks[0].province"
              placeholder="Nhập tỉnh/thành phố"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1 text-nowrap">Ngân hàng</label>
            <b-form-input
              type="text"
              v-model="editData.banks[0].bankName"
              placeholder="Nhập ngân hàng"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1 text-nowrap">STK</label>
            <b-form-input
              type="text"
              v-model="editData.banks[0].accountNumber"
              placeholder="Nhập STK"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1 text-nowrap">Chủ TK</label>
            <b-form-input
              type="text"
              v-model="editData.banks[0].holder"
              placeholder="Nhập chủ TK"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1 text-nowrap">Mật khẩu người dùng</label>
            <b-form-input
              type="text"
              :value="editData.passwordOriginal"
              placeholder="Chưa có"
              class="d-inline-block"
              disabled
            />
          </div>
        </b-form-group>
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1 text-nowrap">Mật khẩu rút tiền</label>
            <b-form-input
              type="text"
              v-model="editData.banks[0].password_withdraw"
              placeholder="Nhập chủ TK"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
      </div>

      <!-- Config Rate CrownSum -->
      <div class="config-rate mt-3 p-3 border rounded">
        <p class="mb-2 font-weight-bold">Cài đặt tỉ lệ người chơi</p>
        <div class="rate-grid">
          <b-form-group label="Lớn" class="mb-0">
            <b-form-input type="number" v-model.numbe="editData.configRate.large" min="0" step="1" />
          </b-form-group>
          <b-form-group label="Nhỏ" class="mb-0">
            <b-form-input type="number" v-model.numbe="editData.configRate.small" min="0" step="1" />
          </b-form-group>
          <b-form-group label="Chẵn" class="mb-0">
            <b-form-input type="number" v-model.numbe="editData.configRate.single" min="0" step="1" />
          </b-form-group>
          <b-form-group label="Lẻ" class="mb-0">
            <b-form-input type="number" v-model.numbe="editData.configRate.double" min="0" step="1" />
          </b-form-group>
        </div>
      </div>

      <!-- Disabled -->
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1 text-nowrap" for="disabled">Khóa</label>
          <b-form-checkbox v-model="editData.isDisabled" id="disabled"></b-form-checkbox>
        </div>
      </b-form-group>

      <template #modal-footer>
        <loading-button variant="primary" @click="editUser">Gửi</loading-button>
      </template>
    </b-modal>

    <!-- Money Modal -->
    <b-modal v-model="showMoneyModal" centered title="Thêm tiền">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1 text-nowrap">Số tiền</label>
          <b-form-input
            type="number"
            v-model="amount"
            placeholder="Nhập số tiền"
            class="d-inline-block"
          />
        </div>
      </b-form-group>

      <template #modal-footer>
        <loading-button variant="danger" @click="addSubtractMoney(-1)">Trừ tiền</loading-button>
        <loading-button variant="primary" @click="addSubtractMoney(1)">Thêm tiền</loading-button>
      </template>
    </b-modal>

    <!-- Delete Confirmation Modal -->
    <b-modal v-model="showDeleteModal" centered title="Xác nhận xóa">
      <p>Bạn có chắc chắn muốn xóa người dùng này?</p>
      <template #modal-footer>
        <b-button variant="secondary" @click="showDeleteModal = false">Hủy</b-button>
        <loading-button variant="danger" @click="deleteUser">Xóa người dùng</loading-button>
      </template>
    </b-modal>

    <!-- Block widthdraw Confirmation Modal -->
    <b-modal v-model="showBlockWithDraw" centered title="Xác nhận khoá rút tiền">
      <p>{{user.isWithdraw ? 'Bạn có chắc chắn muốn mở khoá rút tiền người dùng này?' : 'Bạn có chắc chắn muốn khoá rút tiền người dùng này?'}}</p>
      <template #modal-footer>
        <b-button variant="secondary" @click="showDeleteModal = false">Hủy</b-button>
        <loading-button variant="danger" @click="blockWidthdrawUser">Đồng ý</loading-button>
      </template>
    </b-modal>

     <!-- Block order Confirmation Modal -->
     <b-modal v-model="showBlockOrderModal" centered title="Xác nhận khoá giao dịch">
      <p>{{user.isBet ? 'Bạn có chắc chắn muốn mở khoá giao dịch người dùng này?' : 'Bạn có chắc chắn muốn khoá giao dịch người dùng này?'}}</p>
      <template #modal-footer>
        <b-button variant="secondary" @click="showDeleteModal = false">Hủy</b-button>
        <loading-button variant="danger" @click="blockOrderUser">Đồng ý</loading-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormInput,
  BFormGroup,
  BButton,
  BModal,
  BDropdown,
  BDropdownItem,
  VBTooltip,
  BFormCheckbox,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import LoadingButton from "@/@core/components/loading-button/LoadingButton.vue";
import API from "@/api";

export default {
  props: ["user"],
  components: {
    BFormInput,
    BFormGroup,
    BButton,
    BModal,
    BDropdown,
    BDropdownItem,
    LoadingButton,
    BFormCheckbox,
  },

  data() {
    return {
      showEditModal: false,
      showMoneyModal: false,
      showDeleteModal: false,
      showBlockWithDraw: false,
      showBlockOrderModal: false,
      amount: 0,

      editData: {
        password: "",
        passwordOriginal: "",
        isDisabled: false,
        banks: [],
        username: null,
        money: 0,
        configRate: {
          large: 0,
          small: 0,
          single: 0,
          double: 0,
        }
      },
    };
  },

  methods: {
    onClickshowMoneyModal() {
      this.amount = 0;
      this.showMoneyModal = true;
    },

    onClickShowEditModal() {
      const user = this.user;
      let banks = [];
      console.log(user.banks, 'user.banks')
      if (user.banks.length) {
        banks = [
          {
            accountNumber: user.banks[0].accountNumber,
            bankName: user.banks[0].bankName,
            country: user.banks[0].country,
            holder: user.banks[0].holder,
            password_withdraw: user.banks[0].password_withdraw,
            province: user.banks[0].province,
          },
        ];
      }

      this.editData = {
        password: "",
        passwordOriginal: user.passwordOriginal || "",
        isDisabled: !!user.isDisabled,
        banks: banks,
        username: user.username,
        money: user.money,
        configRate: {
          large: user.configRate?.large || 0,
          small: user.configRate?.small || 0,
          single: user.configRate?.single || 0,
          double: user.configRate?.double || 0,
        }
      };
      this.showEditModal = true;
    },

    onClickShowDeleteModal() {
      this.showDeleteModal = true;
    },

    onClickShowBlockWidthDraw(){
      this.showBlockWithDraw = true;
    },

    onClickShowBlockOrderModal(){
      this.showBlockOrderModal = true;
    },

    async editUser() {
      try {
        const configRateNumber = {}
        for (const key in this.editData.configRate) {
          configRateNumber[key] = Number(this.editData.configRate[key]);
        }
        const data = {
          isDisabled: Number(this.editData.isDisabled),
          banks: this.editData.banks,
          password: this.editData.password,
          configRate: configRateNumber
        };
        if (this.editData.password) {
          data.passwordOriginal = this.editData.password;
        }
        const res = await this.$http.patch(API.USER_EDIT + this.user._id, data);
        if (res.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Cập nhật người dùng thành công.",
              icon: "CheckIcon",
              variant: "success",
            },
          });
          this.showEditModal = false;
          this.$emit("update:user", data);
        } else {
          throw res;
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error?.message || "Lỗi",
            icon: "XIcon",
            variant: "danger",
          },
        });
      }
    },

    async deleteUser() {
      try {
        const res = await this.$http.delete(`${API.USER_DELETE}/${this.user._id}`);
        if (res.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Người dùng ${this.user.username} đã được xóa thành công`,
              icon: "CheckIcon",
              variant: "success",
            },
          });
          this.showDeleteModal = false;
          this.$emit("delete:user", this.user);
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error?.message || "Lỗi khi xóa người dùng",
            icon: "XIcon",
            variant: "danger",
          },
        });
      }
    },

    async blockWidthdrawUser() {
      try {
        const res = await this.$http.patch(`${API.BLOCK_WITHDRAW}/${this.user._id}`);
        if (res.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Thành công',
              icon: "CheckIcon",
              variant: "success",
            },
          });
          this.showBlockWithDraw = false;
          this.$emit("delete:user", this.user);
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error?.message || "Lỗi khi khoá rút tiền người dùng",
            icon: "XIcon",
            variant: "danger",
          },
        });
      }
    },

    async blockOrderUser() {
      try {
        const res = await this.$http.patch(`${API.BLOCK_ORDER}/${this.user._id}`);
        if (res.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Thành công',
              icon: "CheckIcon",
              variant: "success",
            },
          });
          this.showBlockOrderModal = false;
          this.$emit("delete:user", this.user);
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error?.message || "Lỗi khi khoá giao dịch người dùng",
            icon: "XIcon",
            variant: "danger",
          },
        });
      }
    },

    async addSubtractMoney(type) {
      try {
        const data = {
          amount: this.amount * type,
        };
        const res = await this.$http.patch(
          API.USER_MONEY + this.user._id,
          data
        );
        if (res.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Cập nhật người dùng thành công.",
              icon: "CheckIcon",
              variant: "success",
            },
          });
          this.showMoneyModal = false;
          this.$emit("update:user", res.data);
        } else {
          throw res;
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error?.message || "Lỗi",
            icon: "XIcon",
            variant: "danger",
          },
        });
      }
    },
  },

  directives: {
    "b-tooltip": VBTooltip,
  },
};
</script>
<style scoped>
/* Modal form chung */
.b-modal .form-group {
  margin-bottom: 1rem;
}

.b-modal label {
  min-width: 100px;
  font-weight: 500;
  color: #333;
}

.b-modal .form-control,
.b-modal .custom-checkbox .custom-control-input ~ .custom-control-label {
  border-radius: 6px;
  border: 1px solid #ced4da;
  padding: 6px 12px;
  font-size: 0.875rem;
}

.b-modal .form-control:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}

/* D-flex label + input */
.b-modal .d-flex.align-items-center {
  display: flex;
  align-items: center;
  gap: 10px;
}

.b-modal .d-flex.align-items-center label {
  margin-bottom: 0;
  white-space: nowrap;
}

/* Banks section */
.b-modal p {
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #444;
}

/* Config Rate CrownSum */
.config-rate {
  background-color: #f9f9f9;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.config-rate p {
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.rate-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.rate-grid .form-group {
  display: flex;
  flex-direction: column;
}

.rate-grid .form-group label {
  font-size: 0.875rem;
  color: #555;
  margin-bottom: 4px;
}

/* Responsive: nhỏ màn hình xếp 2 cột */
@media (max-width: 768px) {
  .rate-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
